import { LOG_TYPE } from '../const/logger.const';
import { logger } from '../logger/logger.class';
export const navigationErrorHandler = ((navigationError) => {
    return logger.message(navigationError, LOG_TYPE.error);
});
